// extracted by mini-css-extract-plugin
export default {"image":"LCCJnxT2hX","image_twoColumnBigLeft":"aaT3Zj21LB","image_twoColumnBigRight":"gQFJF0wRgK","column":"m3cfh5YdH8"};